import { statuses } from '@/returns/constants'

export const shouldShowIssueRefundConfirmationModal = (
  status,
  issueRefundAtStatus,
  allowsIssueRefund,
  allowsExchangeOrderProcessing
) => {
  return (
    status === statuses.received &&
    status === issueRefundAtStatus &&
    allowsIssueRefund &&
    !allowsExchangeOrderProcessing
  )
}

export const shouldShowIssueExchangeConfirmationModal = (
  status,
  issueExchangeAtStatus,
  allowsExchangeOrderProcessing,
  allowsIssueRefund
) => {
  return (
    status === statuses.received &&
    status === issueExchangeAtStatus &&
    allowsExchangeOrderProcessing &&
    !allowsIssueRefund
  )
}

export const shouldShowIssueExchangeAndRefundConfirmationModal = ({
  status,
  issueExchangeAtStatus,
  allowsExchangeOrderProcessing,
  issueRefundAtStatus,
  allowsIssueRefund,
}) => {
  return (
    status === statuses.received &&
    status === issueExchangeAtStatus &&
    allowsExchangeOrderProcessing &&
    status === issueRefundAtStatus &&
    allowsIssueRefund
  )
}
